<template>
  <v-layout class="grey lighten-4 pa-3" column>
    <div v-if="tabs.length > 1">
      <v-tabs
        v-model="activeTab"
        grow>

        <v-tab v-for="(tab, index) in tabs" :key="`tab-${index}`" :to="{ name: tab.name }">
          {{ $t(tab.tabMenu) }}
        </v-tab>
      </v-tabs>

      <v-tabs-items
        v-model="activeTab"
        touchless>
        <v-tab-item
          transition="fade-transition"
          reverse-transition="fade-transition"
          class="grey lighten-4"
          v-for="(tab, index) in tabs"
          :key="`item-${index}`"
          :value="tab.route">
          <router-view v-if="tab.route === activeTab" />
        </v-tab-item>
      </v-tabs-items>
    </div>

    <div v-else>
      <router-view />
    </div>
  </v-layout>
</template>

<script>
export default {
  name: 'Decreases',
  data () {
    return {
      activeTab: null
    }
  },
  computed: {
    tabs () {
      const tabs = [
        { tabMenu: 'Salida de inventario', name: 'Decreases', route: `/decreases/list`, roles: ['manager', 'buyer'] },
        { tabMenu: 'Captura', name: 'DecreaseCapture', route: `/decreases/capture`, roles: ['manager', 'buyer'] }
      ]
      return tabs.filter(tab => tab.roles.includes(this.$is()))
    },
    area () {
      return this.$route.params.area
    }
  }
}
</script>
